<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class FormValidationRulesMixin extends Vue {
        requiredRule(prop) {
            return v => !!v || v === 0 || `${this.$t(prop)} ${this.$t('validation.required')}`
        }

        emailRule(prop) {
            return v => {
                if (!v) return true

                const basicEmailCheck = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v)
                const noForbiddenChars = !/[(),:;<>[\]\\]/.test(v)

                const isValid = basicEmailCheck && noForbiddenChars && !v.includes('http') && v.length <= 254

                return isValid || `${this.$t(prop)} ${this.$t('validation.valid')}`
            }
        }

        latinRule(prop, fieldKey, params) {
            const reqRules = {
                // latin rule is made exclusively for latin symbols!!!
                // '\u0080-\uFFFF' - allows you to enter Cyrillic
                // and it's not goal of GPFE-4728
                // latin: 'a-zA-Z\u0080-\uFFFF',
                latin: 'a-zA-Z',
                latinAndSpacesOnly: 'a-zA-Z',
                hebrew: '\u0590-\u05FF',
            }
            const regArr = []
            let regExp = new RegExp('')
            let validationText

            if (
                this.$conf.public.personNameValidation &&
                (this.$conf.public.personNameValidation.all === 'latin' ||
                    this.$conf.public.personNameValidation.all === 'latinAndSpacesOnly')
            ) {
                validationText = this.$t('validation.latin', {
                    prop: this.$t(prop),
                })
                regArr.push(reqRules[this.$conf.public.personNameValidation.all])
            }
            if (
                this.$conf.public.personNameValidation &&
                params?.citizenshipId &&
                params?.countryId &&
                params.citizenshipId === params.countryId
            ) {
                for (let key in this.$conf.public.personNameValidation) {
                    if (key === String(params.countryId)) {
                        regArr.push(reqRules[this.$conf.public.personNameValidation[key]])
                        validationText +=
                            ` ${this.$t('or')} ` + this.$t(`validation.${this.$conf.public.personNameValidation[key]}`)
                    }
                }
            }
            if (regArr.length) {
                if (this.$conf.public.personNameValidation.all === 'latinAndSpacesOnly') {
                    regExp = new RegExp(`^[${regArr.join('')}\\s]*$`, 'i')
                } else {
                    regExp = new RegExp(`^[${regArr.join('')}\\s-\`'-]*$`, 'i')
                }
            }

            return v => !this.$conf.public.personNameValidation || regExp.test(v) || validationText
        }

        validationRules(prop, ruleFns, fieldKey, params) {
            return ruleFns.map(ruleFn => ruleFn(prop, fieldKey, params))
        }

        lengthRule(length) {
            return value => value.length >= length || `${length} ${this.$t('validation.length')}`
        }

        positiveNumberRule(prop) {
            return value => +value >= 0 || this.$t('validation.positiveNumber', {prop})
        }
    }

    export default FormValidationRulesMixin
</script>
